import { Box, Heading, Stack } from "@chakra-ui/react";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../../components/BackButton";
import HybridBottomSheetDrawer from "../../components/HybridBottomSheetDrawer";
import LaundretteCard from "../../components/laundrette/LaundretteCard";
import QueryStateWrapper from "../../components/QueryStateWrapper";
import { useLaundrettes } from "../../data/laundrette.api";
import { useFocusOnPoints } from "../../hooks/useFocusOnPoints";

type Props = {};

const AllLaundrettes = (props: Props) => {
  const { data, isLoading, error, isSuccess } = useLaundrettes();
  const navigate = useNavigate();

  const points = useMemo(() => {
    return (
      data?.map((laundrette) => ({
        lng: laundrette.details.lng,
        lat: laundrette.details.lat,
        onClick: () =>
          navigate(`/laundry/${laundrette.overview.laundryroom.location}`),
      })) ?? []
    );
  }, [data, navigate]);

  useFocusOnPoints(points);

  return (
    <HybridBottomSheetDrawer>
      <BackButton />
      <Box p={8}>
        <Heading size="md" mb={4}>
          Laundrettes
        </Heading>
        <QueryStateWrapper data={data} isLoading={isLoading} error={error}>
          <Stack>
            {data?.map((laundrette) => (
              <LaundretteCard laundrette={laundrette.overview} />
            ))}
          </Stack>
        </QueryStateWrapper>
      </Box>
    </HybridBottomSheetDrawer>
  );
};

export default AllLaundrettes;
